/*
 * Before updating the version, make sure you have
 * read and followed the "Guidelines for updating versioned
 * state types" section in the README
 */
/*
 * The palletizing patterns ("presets") a stacking layer of cardboard boxes can
 * be arranged in. The pattern is stored, not just its result, so the boxes can
 * be laid out again when the box or pallet size changes.
 *
 * The values are persisted, so this enum is owned by the versioned state (like
 * `Pallet`) and read from there by the pattern maths in `3d/pallet-patterns`.
 * Adding or renaming a pattern means a new state version and a migration.
 */
export var PalletPatternId;
(function (PalletPatternId) {
    PalletPatternId["SINGLE"] = "single";
    PalletPatternId["BLOCK"] = "block";
    PalletPatternId["ROTATED_ROWS"] = "rotatedRows";
    PalletPatternId["BRICK"] = "brick";
    PalletPatternId["PINWHEEL"] = "pinwheel";
})(PalletPatternId || (PalletPatternId = {}));
/*
 * How a stacking layer's palletizing pattern is transformed before the boxes
 * are placed. Real stacks interlock by making each layer differ from the one
 * below — identical layers are what makes a stack fall over — so a layer can
 * mirror or turn the pattern it is built from.
 *
 * Persisted, so (like `PalletPatternId`) this enum is owned by the versioned
 * state and read from there by the pattern maths in `3d/pallet-patterns`.
 */
export var PatternTransform;
(function (PatternTransform) {
    PatternTransform["NONE"] = "none";
    /** Reflect the layout across the pallet's long (X) axis. */
    PatternTransform["MIRROR"] = "mirror";
    /** Turn the whole layout a quarter turn about the pallet centre. */
    PatternTransform["TURN"] = "turn";
})(PatternTransform || (PatternTransform = {}));
export { ObjectShapeId, TubeType, GripPositionMarkerId, NodeComponentType, GlassObjectShapeId, PlasticObjectShapeId, MetalObjectShapeId, CardboardObjectShapeId, TubeConnectionId, } from "./types.v9";
